export { default } from './AccommodationAvailableAddons'
